<template>
  <fieldset class="step step--7">
    <Section :title="stepTitle">
      <CertificationFormGroup name="q_7_1">
        <TrueFalseControl
          id="q_7_1"
          v-model="form.q_7_1"
          number="1"
          label="Materiały konferencyjne/strona internetowa zawierają elementy podkreślające walory turystyczne/rozrywkowe lokalizacji geograficznej lub obiektu, w którym organizowane jest wydarzenie"
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
    </Section>
  </fieldset>
</template>

<script>
import BaseCertificationFormStep from "@/components/Base/Certification/BaseCertificationFormStep";
import TrueFalseControl from "@/components/Controls/TrueFalseControl";

export default {
  name: "CertificationFormStep7",
  components: {
    TrueFalseControl
  },
  extends: BaseCertificationFormStep
};
</script>
